export default __webpack_public_path__ + "c7da2b1784812ed93baa8aafd7268819.png";